import axios from 'axios';
import RestService from '../../../helpers/RestService';

axios.defaults.headers.common = {
  'Accept': 'application/json, text/plain',
  'X-CSRF-Token': RestService.getCsrfToken(),
  'X-Requested-With' : 'XMLHttpRequest',
};

export async function getUsers(){
  try {
    let data = await axios({
      method: 'post',
      url:'/api/user-email-book/users',
      headers: {
          'Accept': 'application/json, text/plain',
          'X-CSRF-Token': RestService.getCsrfToken(),
          'X-Requested-With' : 'XMLHttpRequest',
      }
    }).then(res => res.data);
    return data;
  } catch (error) {
  }
  
}


export async function createUser(data){
  var bodyFormData = new FormData();
  Object.keys(data).forEach(key => {
    bodyFormData.set(key, data[key]);
  });

  try {
    let data = await axios({
      method: 'post',
      url:'/api/user-email-book/create',
      headers: {
          'Accept': 'application/json, text/plain',
          'X-CSRF-Token': RestService.getCsrfToken(),
          'X-Requested-With' : 'XMLHttpRequest',
          'Content-Type': 'multipart/form-data'
      },
      data: bodyFormData,
    }).then(res => res.data);
    return data;
  } catch (error) {
  }
  
}

export async function deleteUser(data){
  var bodyFormData = new FormData();
  Object.keys(data).forEach(key => {
    bodyFormData.set(key, data[key]);
  });

  try {
    let data = await axios({
      method: 'post',
      url:'/api/user-email-book/delete',
      headers: {
          'Accept': 'application/json, text/plain',
          'X-CSRF-Token': RestService.getCsrfToken(),
          'X-Requested-With' : 'XMLHttpRequest',
          'Content-Type': 'multipart/form-data'
      },
      data: bodyFormData,
    }).then(res => res.data);
    return data;
  } catch (error) {
  }
  
}


// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/components/QbmPage/QbmUserBooks/actions.js